import Link from "components/shared/Link";
import Title from "components/footer/Title";
import { useContext } from "react";
import { Context } from "Context";
import appConfig from "config.json";
import { validateItemAffiliations } from "utils/affiliations";

const { hideMobileFooterLinks } = appConfig;
const mainClass = "syndicated-footer__list__column__section";
const Column = ({
	title,
	href,
	analyticsLinkId,
	id,
	webLinkList = [],
	informativeLabels = [],
	innerHtml = false,
	isMobileView = false,
}) => {
	const {
		config: { openFooterLinksInNewTab },
		profileData: { affiliations },
	} = useContext(Context);

	const ariaLabelledById = id ? `navigationFooter-${id}` : null;

	return (
		<div className={`${mainClass}${id ? ` ${mainClass}--${id}` : ""}`}>
			{href ? (
				<Link
					analyticsLinkId={analyticsLinkId}
					title={title}
					href={href}
					className="syndicated-footer__title"
				/>
			) : (
				<Title title={title} ariaLabelledById={ariaLabelledById} />
			)}
			<ul className={`${mainClass}__group`} aria-labelledby={ariaLabelledById}>
				{webLinkList?.map((link, index, ...rest) => {
					if (!validateItemAffiliations(link, affiliations)) {
						return null;
					} else if (
						openFooterLinksInNewTab &&
						(!link.target || link.target === "_self")
					) {
						link.target = "_blank";
					}
					if (
						isMobileView &&
						hideMobileFooterLinks?.some((item) => link?.href?.includes(item))
					) {
						return null;
					}
					return (
						<li key={index} className={`${mainClass}__group__item`}>
							<Link
								{...link}
								innerHtml={innerHtml}
								className="syndicated-footer__link"
							/>
						</li>
					);
				})}
			</ul>
			{informativeLabels.length > 0 && (
				<ul className={`${mainClass}__group-info-labels`}>
					{informativeLabels.map((label, index) => (
						<li
							key={index}
							className={`${mainClass}__group-info-labels__item`}
							dangerouslySetInnerHTML={{ __html: label.title }}
						/>
					))}
				</ul>
			)}
		</div>
	);
};

export default Column;
